export const FillingLevelIcon = () => (
  <svg
    width="11"
    height="13"
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M5.33333 12.2667C3.85556 12.2667 2.59722 11.7556 1.55833 10.7333C0.519445 9.71111 0 8.46667 0 7C0 6.27778 0.138889 5.60278 0.416667 4.975C0.694444 4.34722 1.07778 3.78889 1.56667 3.3L4.63333 0.283333C4.73333 0.194444 4.84444 0.125 4.96667 0.075C5.08889 0.025 5.21111 0 5.33333 0C5.45556 0 5.57778 0.025 5.7 0.075C5.82222 0.125 5.93333 0.194444 6.03333 0.283333L9.1 3.3C9.58889 3.78889 9.97222 4.34722 10.25 4.975C10.5278 5.60278 10.6667 6.27778 10.6667 7C10.6667 8.46667 10.1472 9.71111 9.10833 10.7333C8.06944 11.7556 6.81111 12.2667 5.33333 12.2667ZM1.36667 7.6H9.26667C9.4 6.8 9.325 6.11667 9.04167 5.55C8.75833 4.98333 8.46667 4.55556 8.16667 4.26667L5.33333 1.46667L2.5 4.26667C2.2 4.55556 1.90556 4.98333 1.61667 5.55C1.32778 6.11667 1.24444 6.8 1.36667 7.6Z"
      fill="#222222"
    />
  </svg>
);

export const WeightTonsIcon = () => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M1.33129 10.6667H9.33129L8.38129 4H2.28129L1.33129 10.6667ZM5.33129 2.66667C5.52018 2.66667 5.67851 2.60278 5.80629 2.475C5.93406 2.34722 5.99795 2.18889 5.99795 2C5.99795 1.81111 5.93406 1.65278 5.80629 1.525C5.67851 1.39722 5.52018 1.33333 5.33129 1.33333C5.1424 1.33333 4.98406 1.39722 4.85629 1.525C4.72851 1.65278 4.66462 1.81111 4.66462 2C4.66462 2.18889 4.72851 2.34722 4.85629 2.475C4.98406 2.60278 5.1424 2.66667 5.33129 2.66667ZM7.21462 2.66667H8.38129C8.71462 2.66667 9.00351 2.77778 9.24795 3C9.4924 3.22222 9.6424 3.49444 9.69795 3.81667L10.648 10.4833C10.7035 10.8833 10.6007 11.2361 10.3396 11.5417C10.0785 11.8472 9.7424 12 9.33129 12H1.33129C0.920175 12 0.584064 11.8472 0.322953 11.5417C0.0618421 11.2361 -0.0409357 10.8833 0.0146199 10.4833L0.96462 3.81667C1.02018 3.49444 1.17018 3.22222 1.41462 3C1.65906 2.77778 1.94795 2.66667 2.28129 2.66667H3.44795C3.41462 2.55556 3.38684 2.44722 3.36462 2.34167C3.3424 2.23611 3.33129 2.12222 3.33129 2C3.33129 1.44444 3.52573 0.972222 3.91462 0.583333C4.30351 0.194444 4.77573 0 5.33129 0C5.88684 0 6.35906 0.194444 6.74795 0.583333C7.13684 0.972222 7.33129 1.44444 7.33129 2C7.33129 2.12222 7.32018 2.23611 7.29795 2.34167C7.27573 2.44722 7.24795 2.55556 7.21462 2.66667Z"
      fill="#222222"
    />
  </svg>
);

export const CompactionIcon = () => (
  <svg
    width="15"
    height="11"
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M1.98333 10.6667C1.42778 10.6667 0.958333 10.4722 0.575 10.0833C0.191667 9.69444 0 9.22222 0 8.66667V4.66667C0 4.3 0.130556 3.98611 0.391667 3.725C0.652778 3.46389 0.966667 3.33333 1.33333 3.33333H4.66667V0.666667C4.66667 0.477778 4.73056 0.319444 4.85833 0.191667C4.98611 0.0638889 5.14444 0 5.33333 0H8C8.55556 0 9.025 0.194444 9.40833 0.583333C9.79167 0.972222 9.98333 1.44444 9.98333 2V4.66667H10.65V3.88333C10.65 3.70556 10.6861 3.53333 10.7583 3.36667C10.8306 3.2 10.9278 3.05556 11.05 2.93333L11.7 2.3C11.8556 2.14444 12.0417 2.08333 12.2583 2.11667C12.475 2.15 12.6389 2.26667 12.75 2.46667L14.8 6.35C14.9222 6.57222 14.9194 6.79167 14.7917 7.00833C14.6639 7.225 14.4722 7.33333 14.2167 7.33333H11.9833C11.6167 7.33333 11.3028 7.20278 11.0417 6.94167C10.7806 6.68056 10.65 6.36667 10.65 6H9.98333V7.16667C10.2056 7.35556 10.375 7.58056 10.4917 7.84167C10.6083 8.10278 10.6667 8.37778 10.6667 8.66667C10.6667 9.22222 10.4722 9.69444 10.0833 10.0833C9.69444 10.4722 9.22222 10.6667 8.66667 10.6667C8.24444 10.6667 7.86111 10.5444 7.51667 10.3C7.17222 10.0556 6.92222 9.73333 6.76667 9.33333H3.88333C3.72778 9.73333 3.47778 10.0556 3.13333 10.3C2.78889 10.5444 2.40556 10.6667 1.98333 10.6667ZM1.98333 9.33333C2.17222 9.33333 2.33333 9.26945 2.46667 9.14167C2.6 9.01389 2.66667 8.85556 2.66667 8.66667C2.66667 8.47778 2.60278 8.31944 2.475 8.19167C2.34722 8.06389 2.18889 8 2 8C1.81111 8 1.65278 8.06389 1.525 8.19167C1.39722 8.31944 1.33333 8.47778 1.33333 8.66667C1.33333 8.85556 1.39444 9.01389 1.51667 9.14167C1.63889 9.26945 1.79444 9.33333 1.98333 9.33333ZM8.66667 9.33333C8.85556 9.33333 9.01389 9.26945 9.14167 9.14167C9.26945 9.01389 9.33333 8.85556 9.33333 8.66667C9.33333 8.47778 9.26945 8.31944 9.14167 8.19167C9.01389 8.06389 8.85556 8 8.66667 8C8.47778 8 8.31944 8.06389 8.19167 8.19167C8.06389 8.31944 8 8.47778 8 8.66667C8 8.85556 8.06389 9.01389 8.19167 9.14167C8.31944 9.26945 8.47778 9.33333 8.66667 9.33333ZM4.66667 8V4.66667H1.33333V6.78333C1.44444 6.73889 1.55278 6.70833 1.65833 6.69167C1.76389 6.675 1.87778 6.66667 2 6.66667C2.42222 6.66667 2.80556 6.78889 3.15 7.03333C3.49444 7.27778 3.73889 7.6 3.88333 8H4.66667ZM6 8H6.76667C6.91111 7.6 7.15833 7.27778 7.50833 7.03333C7.85833 6.78889 8.24444 6.66667 8.66667 6.66667V6H6V8ZM13.1167 6L12 3.88333V6H13.1167ZM6 4.66667H8.66667V2C8.66667 1.81111 8.60278 1.65278 8.475 1.525C8.34722 1.39722 8.18889 1.33333 8 1.33333H6V4.66667ZM4.66667 8V6.66667V6.78333V4.66667V8Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const ImportedDocumentIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M2.66667 10.6667H8V9.33333H2.66667V10.6667ZM2.66667 8H8V6.66667H2.66667V8ZM1.33333 13.3333C0.966667 13.3333 0.652778 13.2028 0.391667 12.9417C0.130556 12.6806 0 12.3667 0 12V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6.66667L10.6667 4V12C10.6667 12.3667 10.5361 12.6806 10.275 12.9417C10.0139 13.2028 9.7 13.3333 9.33333 13.3333H1.33333ZM6 4.66667V1.33333H1.33333V12H9.33333V4.66667H6Z"
      fill="#222222"
    />
  </svg>
);

export const NotesIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M2.66667 8H8V6.66667H2.66667V8ZM2.66667 6H10.6667V4.66667H2.66667V6ZM2.66667 4H10.6667V2.66667H2.66667V4ZM0 13.3333V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667H2.66667L0 13.3333ZM2.1 9.33333H12V1.33333H1.33333V10.0833L2.1 9.33333Z"
      fill="#222222"
    />
  </svg>
);
